import { RecursiveStringifyEnums } from './buildDistro';
import { IntegrationProvider } from './../types';

export const mockedIntegrationProviders: { integrationProviders: RecursiveStringifyEnums<IntegrationProvider[]> } = {
    integrationProviders: [
        {
            id: 'jira:12345',
            type: 'jira',
            name: 'Jira',
            appIds: ['appollo-ios', 'appollo-android', 'appollo-react-native-ota'],
            installedIntegrationTypesByAppId: {
                'appollo-ios': ['jira'],
                'appollo-android': ['jira'],
                'appollo-react-native-ota': ['jira'],
            },
            data: {
                doneStatuses: ['Done', 'Deployed', 'Ready for Release'],
                availableAdditionalDoneStatuses: [
                    'In Progress',
                    'Backlog',
                    'Selected for Development',
                    'QA',
                    'To Do',
                    'QA In Progress',
                ],
                availableProjects: [
                    { id: '10000', key: 'DEMO', name: 'Demo' },
                    { id: '10001', key: 'DEMO-CORE', name: 'Demo-Core' },
                ],
                featureAffiliationTypes: [
                    { affiliationType: 'jira-label', name: 'Label' },
                    { affiliationType: 'jira-fix-version', name: 'Fix Version' },
                ],
                permissions: [
                    { type: 'jira-users', value: 'read' },
                    { type: 'jira-project', value: 'manage' },
                    { type: 'jira-work', value: 'write' },
                ],
                cloudUrl: 'somesubdomain.atlassian.net',
                onPremUrl: 'somesubdomain.ourdomain.com',
                canOfferAutoSelectAllProjects: true,
            },
        },
        {
            id: 'sentry:12345',
            type: 'sentry',
            name: 'Sentry',
            appIds: ['voyager-ota'],
            installedIntegrationTypesByAppId: {
                'voyager-ota': ['sentry'],
            },
            data: {
                availableOrgsAndProjects: [
                    {
                        orgId: '12345',
                        orgName: 'Demo',
                        projects: [
                            {
                                id: 'abc',
                                displayableName: 'demo-ios',
                                orgId: '12345',
                                environments: ['development', 'production'],
                            },
                            {
                                id: 'def',
                                displayableName: 'demo-android',
                                orgId: '12345',
                                environments: ['development', 'production'],
                            },
                        ],
                    },
                ],
            },
        },
        {
            id: 'testrail:12345',
            type: 'testrail',
            name: 'TestRail',
            appIds: [],
            installedIntegrationTypesByAppId: {},
            data: {
                availableProjects: [
                    { id: '1', name: 'Demo Testrail iOS', isSingleSuite: true },
                    { id: '2', name: 'Demo Testrail Android', isSingleSuite: true },
                ],
                allStatuses: [{ id: '1', name: 'status-name', displayableName: 'Named Status' }],
                username: 'dave',
                baseUrl: 'www.example.com',
            },
        },
        {
            id: 'buildkite:12345',
            type: 'buildkite',
            name: 'Buildkite',
            appIds: [],
            installedIntegrationTypesByAppId: {},
            data: {
                availableOrgsAndPipelines: [
                    {
                        org: {
                            id: 'some-org-id',
                            slug: 'some-org-slug',
                            name: 'Some Org Name',
                        },
                        pipelines: [
                            {
                                id: 'some-pipeline-id',
                                slug: 'some-pipeline-slug',
                                name: 'Some Pipeline Name',
                            },
                            {
                                id: 'some-pipeline-id-2',
                                slug: 'some-pipeline-slug-2',
                                name: 'Some Pipeline Name 2',
                            },
                            {
                                id: 'some-pipeline-id-3',
                                slug: 'some-pipeline-slug-3',
                                name: 'Some Pipeline Name 3',
                            },
                        ],
                    },
                    {
                        org: {
                            id: 'some-other-org-id',
                            slug: 'some-other-org-slug',
                            name: 'Some Other Org Name',
                        },
                        pipelines: [
                            {
                                id: 'some-other-pipeline-id',
                                slug: 'some-other-pipeline-slug',
                                name: 'Some Other Pipeline Name',
                            },
                            {
                                id: 'some-other-pipeline-id-2',
                                slug: 'some-other-pipeline-slug-2',
                                name: 'Some Other Pipeline Name 2',
                            },
                            {
                                id: 'some-other-pipeline-id-3',
                                slug: 'some-other-pipeline-slug-3',
                                name: 'Some Other Pipeline Name 3',
                            },
                        ],
                    },
                ],
                tokenScopes: ['scope_1', 'scope_2', 'scope_3'],
            },
        },
        {
            id: 'codemagic:12345',
            type: 'codemagic',
            name: 'Code Magic',
            appIds: ['appollo-ios'],
            installedIntegrationTypesByAppId: {
                'appollo-ios': ['codemagic'],
            },
            data: {
                availableApps: [
                    {
                        id: 'some-app-id',
                        appName: 'Some App Name',
                        workflows: {
                            'some identifier': {
                                name: 'some-workflow-name',
                            },
                            'some other identifier': {
                                name: 'some-other-workflow-name',
                            },
                            'yet another identifier': {
                                name: 'yet-another-workflow-name',
                            },
                            'you guessed it': {
                                name: 'its-another-workflow-name',
                            },
                        },
                    },
                    {
                        id: 'some-other-app-id',
                        appName: 'Some Other App Name',
                        workflows: {
                            'some identifier': {
                                name: 'some-workflow-name',
                            },
                            'another identifier': {
                                name: 'another-workflow-name',
                            },
                        },
                    },
                ],
            },
        },
        {
            id: 'pivotal:12345',
            type: 'pivotal',
            name: 'Pivotal',
            appIds: [],
            installedIntegrationTypesByAppId: {},
            data: {
                availableProjects: [
                    { id: '1', name: 'Demo Pivotal iOS' },
                    { id: '2', name: 'Demo 2 Pivotal iOS' },
                    { id: '3', name: 'Demo 3 Pivotal iOS' },
                    { id: '4', name: 'Demo Pivotal Android' },
                ],
                featureAffiliationTypes: [{ affiliationType: 'pivotal-label', name: 'Label' }],
            },
        },
        {
            id: 'shortcut:12345',
            type: 'shortcut',
            name: 'Shotcut',
            appIds: [],
            installedIntegrationTypesByAppId: {},
            data: {
                doneStatuses: [
                    {
                        id: 1234,
                        name: 'Done',
                    },
                    {
                        id: 5678,
                        name: 'In Progress',
                    },
                ],
                availableAdditionalDoneStatuses: [
                    {
                        id: 2345,
                        name: 'Actionable',
                    },
                    {
                        id: 3456,
                        name: 'Pending Review',
                    },
                    {
                        id: 4567,
                        name: 'On The Docket',
                    },
                    {
                        id: 6789,
                        name: 'Off The Docket',
                    },
                ],
                availableGroups: [
                    {
                        id: 'group-1-identifier',
                        name: 'Group 1',
                    },
                    {
                        id: 'group-2-identifier',
                        name: 'Group 2',
                    },
                    {
                        id: 'group-3-identifier',
                        name: 'Group 3',
                    },
                    {
                        id: 'group-4-identifier',
                        name: 'Group 4',
                    },
                ],
                availableMembers: [
                    {
                        id: 'member-1-identifier',
                        profile: {
                            name: 'member-name-1',
                            id: 'member-1-profile-id',
                        },
                    },
                    {
                        id: 'member-2-identifier',
                        profile: {
                            name: 'member-name-2',
                            id: 'member-2-profile-id',
                        },
                    },
                    {
                        id: 'member-3-identifier',
                        profile: {
                            name: 'member-name-3',
                            id: 'member-3-profile-id',
                        },
                    },
                ],
                featureAffiliationTypes: [{ affiliationType: 'shortcut-label', name: 'Label' }],
            },
        },
        {
            id: 'monday:12345',
            type: 'monday',
            name: 'Monday',
            appIds: ['appollo-ios'],
            installedIntegrationTypesByAppId: {
                'appollo-ios': ['monday'],
            },
            data: {
                availableBoards: [
                    {
                        id: 'board-1-identifier',
                        name: 'Board #1',
                        columns: [
                            {
                                id: 'column-1-identifier',
                                name: 'Column #1',
                            },
                            {
                                id: 'column-2-identifier',
                                name: 'Column #2',
                            },
                            {
                                id: 'column-3-identifier',
                                name: 'Column #3',
                            },
                            {
                                id: 'column-4-identifier',
                                name: 'Column #4',
                            },
                        ],
                    },
                    {
                        id: 'board-2-identifier',
                        name: 'Board #2',
                        columns: [
                            {
                                id: 'column-1-identifier',
                                name: 'Column #1',
                            },
                            {
                                id: 'column-2-identifier',
                                name: 'Column #2',
                            },
                            {
                                id: 'column-3-identifier',
                                name: 'Column #3',
                            },
                        ],
                    },
                    {
                        id: 'board-3-identifier',
                        name: 'Board #3',
                        columns: [
                            {
                                id: 'column-1-identifier',
                                name: 'Column #1',
                            },
                            {
                                id: 'column-2-identifier',
                                name: 'Column #2',
                            },
                        ],
                    },
                    {
                        id: 'board-4-identifier',
                        name: 'Board #4',
                        columns: [],
                    },
                ],
                featureAffiliationTypes: [{ affiliationType: 'monday-column', name: 'Column' }],
            },
        },
        {
            id: 'runway-build-distro:12345',
            type: 'runway-build-distro',
            name: 'Runway Build Distro',
            appIds: [],
            installedIntegrationTypesByAppId: {},
            data: {
                availableAppsAndBuckets: {
                    'app-identifier-1': [
                        {
                            id: 'bucket-id-1',
                            name: 'bucket-id-2',
                            type: 'custom',
                        },
                        {
                            id: 'bucket-id-2',
                            name: 'bucket-id-2',
                            type: 'personal',
                        },
                        {
                            id: 'bucket-id-3',
                            name: 'bucket-id-3',
                            type: 'rc',
                        },
                        {
                            id: 'bucket-id-4',
                            name: 'bucket-id-4',
                            type: 'dev',
                        },
                    ],
                    'app-identifier-2': [
                        {
                            id: 'bucket-id-1',
                            name: 'bucket-id-2',
                            type: 'custom',
                        },
                        {
                            id: 'bucket-id-2',
                            name: 'bucket-id-2',
                            type: 'personal',
                        },
                    ],
                    'app-identifier-3': [
                        {
                            id: 'bucket-id-1',
                            name: 'bucket-id-2',
                            type: 'custom',
                        },
                    ],
                    'app-identifier-4': [
                        {
                            id: 'bucket-id-1',
                            name: 'bucket-id-2',
                            type: 'custom',
                        },
                    ],
                },
            },
        },
        {
            id: 'bugsnag:12345',
            type: 'bugsnag',
            name: 'Bugsnag',
            appIds: ['appollo-ios'],
            installedIntegrationTypesByAppId: {
                'appollo-ios': ['bugsnag'],
            },
            data: {
                availableOrgsAndProjects: [
                    {
                        orgId: '12345',
                        orgName: 'Demo',
                        projects: [
                            {
                                id: 'abc',
                                orgId: '12345',
                                name: 'demo-ios',
                                releaseStages: ['stage1', 'stage2', 'stage3', 'stage4'],
                            },
                            {
                                id: 'def',
                                orgId: '45678',
                                name: 'demo-android',
                                releaseStages: ['stage1', 'stage2', 'stage3'],
                            },
                            {
                                id: 'ghi',
                                orgId: '34567',
                                name: 'demo-2-ios',
                                releaseStages: ['stage1'],
                            },
                            {
                                id: 'jkl',
                                orgId: '56789',
                                name: 'demo-2-android',
                                releaseStages: ['stage1', 'stage2'],
                            },
                        ],
                    },
                ],
            },
        },
        {
            id: 'embrace:12345',
            type: 'embrace',
            name: 'Embrace',
            appIds: [],
            installedIntegrationTypesByAppId: {},
            data: {
                allApps: [
                    {
                        id: 'app-id-1',
                        name: 'App Name 1',
                        platform: 'ios',
                        environment: 'staging',
                    },
                    {
                        id: 'app-id-2',
                        name: 'App Name 2',
                        platform: 'android',
                        environment: 'prod',
                    },
                    {
                        id: 'app-id-3',
                        name: 'App Name 3',
                        platform: 'ios-sdk',
                        environment: 'beta',
                    },
                    {
                        id: 'app-id-4',
                        name: 'App Name 4',
                        platform: 'android-sdk',
                        environment: 'beta',
                    },
                ],
            },
        },
        {
            id: 'xray:12345',
            type: 'xray',
            name: 'Xray',
            appIds: [],
            installedIntegrationTypesByAppId: {},
            data: {
                clientId: '123435678910',
            },
        },
        {
            id: 'apple:12345',
            type: 'apple',
            name: 'App Store Connect',
            appIds: [],
            installedIntegrationTypesByAppId: {},
            data: {
                availableProductsAndWorkflows: [],
                availableApps: [
                    {
                        bundleId: 'com.demo.demo',
                        appId: 12345678,
                        betaGroups: [
                            {
                                id: 'aaa',
                                name: 'External beta testers',
                                isExternal: true,
                                isEligibleAsDefaultBetaGroup: true,
                            },
                            {
                                id: 'bbb',
                                name: 'Alpha testers',
                                isExternal: true,
                                isEligibleAsDefaultBetaGroup: true,
                            },
                            {
                                id: 'ccc',
                                name: 'The Best People',
                                isExternal: false,
                                isEligibleAsDefaultBetaGroup: true,
                            },
                        ],
                    },
                ],
                availablePowerAndPerformanceMetrics: [],
                keyId: '1234',
                issuerId: '5678',
            },
        },
        {
            id: 'bitrise:12345',
            type: 'bitrise',
            name: 'Bitrise',
            appIds: [],
            installedIntegrationTypesByAppId: {},
            data: {
                availableApps: [
                    {
                        slug: 'abc-def-ghi',
                        title: 'demo-ios',
                        workflows: ['build', 'deploy', 'primary'],
                    },
                    {
                        slug: '123-456-789',
                        title: 'demo-android',
                        workflows: ['build', 'deploy', 'primary'],
                    },
                ],
            },
        },
        {
            id: 'github:12345',
            type: 'github',
            name: 'GitHub',
            appIds: ['appollo-ios', 'appollo-android', 'voyager', 'voyager-ota'],
            installedIntegrationTypesByAppId: {
                'appollo-ios': ['github'],
                'appollo-android': ['github-ci'],
                voyager: ['github', 'github-ci'],
                'voyager-ota': ['github', 'github-ci'],
            },
            data: {
                availableRepos: ['demo-ios', 'demo-android', 'voyager-mobile'],
                availableWorkflows: {
                    'demo-ios': [],
                    'demo-android': [],
                    'voyager-mobile': [
                        {
                            id: 'mobile-release.yml',
                            name: 'Mobile Release',
                            repo: 'voyager-mobile',
                            url: 'https://github.com/runway-demo/voyager-mobile/actions/workflows/mobile-release.yml',
                        },
                        {
                            id: 'ota-staging.yml',
                            name: 'OTA Staging Release',
                            repo: 'voyager-mobile',
                            url: 'https://github.com/runway-demo/voyager-mobile/actions/workflows/ota-staging.yml',
                        },
                        {
                            id: 'ota-production.yml',
                            name: 'OTA Production Publish',
                            repo: 'voyager-mobile',
                            url: 'https://github.com/runway-demo/voyager-mobile/actions/workflows/ota-production.yml',
                        },
                    ],
                },
                gitHubPermissions: [
                    { type: 'metadata', value: 'read' },
                    { type: 'pullRequests', value: 'write' },
                    { type: 'actions', value: 'write' },
                    { type: 'contents', value: 'write' },
                    { type: 'webhooks', value: 'write' },
                ],
                supportsStatusChecks: true,
                supportsPRComments: true,
                supportsDirectPushCheck: true,
                onPremUrl: 'www.ourdomain.com',
                gitHubAppId: '1234',
                featureAffiliationTypes: [],
                issuesDoneStates: [],
                issuesAvailableAdditionalDoneStates: [],
            },
        },
        {
            id: 'google:abcdefg',
            type: 'google',
            name: 'Google',
            appIds: ['appollo-ios', 'appollo-android', 'appollo-react-native-ota', 'voyager-ota'],
            installedIntegrationTypesByAppId: {
                'appollo-ios': ['google-analytics'],
                'appollo-android': ['google-beta'],
                'appollo-react-native-ota': ['google-beta', 'google-analytics'],
            },
            data: {
                projectsResources: [],
                analyticsResources: {
                    dataStreams: [],
                    allEventNames: [],
                    allMetrics: [],
                },
                androidVitalsResources: {
                    allMetrics: [],
                    allApps: [],
                },
            },
        },
        {
            id: 'google:hijklmnop',
            type: 'google',
            name: 'Google',
            appIds: ['appollo-ios', 'appollo-android', 'appollo-react-native-ota'],
            installedIntegrationTypesByAppId: {
                'appollo-ios': ['google-calendar'],
                'appollo-android': ['google-calendar'],
                'appollo-react-native-ota': ['google-calendar'],
            },
            data: {
                projectsResources: [],
                analyticsResources: {
                    dataStreams: [],
                    allEventNames: [],
                    allMetrics: [],
                },
                androidVitalsResources: {
                    allMetrics: [],
                    allApps: [],
                },
            },
        },
        {
            id: 'slack:abcdefg',
            type: 'slack',
            name: 'Slack',
            appIds: ['appollo-ios', 'appollo-android', 'appollo-react-native-ota'],
            installedIntegrationTypesByAppId: {
                'appollo-ios': ['slack'],
                'appollo-android': ['slack'],
                'appollo-react-native-ota': ['slack'],
            },
            data: {
                availableChannels: [],
                availableGroups: [],
                scopes: 'app_mentions:read,commands,channels:join,channels:manage,channels:read',
                slackTeam: 'demoteam',
            },
        },
        {
            id: 'amplitude:abcdefg',
            type: 'amplitude',
            name: 'Amplitude',
            appIds: ['appollo-ios', 'appollo-android', 'appollo-react-native-ota'],
            installedIntegrationTypesByAppId: {
                'appollo-ios': ['amplitude'],
                'appollo-android': ['amplitude'],
                'appollo-react-native-ota': ['amplitude'],
                'voyager-ota': ['amplitude'],
            },
            data: {
                allUserProperties: [],
                allEventTypes: [],
                shouldUseEUServer: true,
            },
        },
        {
            id: 'optimizely:abcdefg',
            type: 'optimizely',
            name: 'Optimizely',
            appIds: ['appollo-ios', 'appollo-android', 'appollo-react-native-ota'],
            installedIntegrationTypesByAppId: {
                'appollo-ios': ['optimizely'],
                'appollo-android': ['optimizely'],
                'appollo-react-native-ota': ['optimizely'],
            },
            data: {
                projects: [
                    {
                        id: '123456',
                        name: 'Appollo project',
                        isUsingFlagsAPI: true,
                        isClassic: false,
                    },
                ],
                environments: {
                    production: [
                        {
                            id: 'production',
                            name: 'Production',
                        },
                    ],
                },
                versionAttributeName: 'app_version',
            },
        },
        {
            id: 'pagerduty:abcdefg',
            type: 'pagerduty',
            name: 'PagerDuty',
            appIds: ['appollo-ios', 'appollo-android', 'appollo-react-native-ota'],
            installedIntegrationTypesByAppId: {
                'appollo-ios': ['pagerduty-scheduling'],
                'appollo-android': ['pagerduty-scheduling'],
                'appollo-react-native-ota': ['pagerduty-scheduling'],
            },
            data: {
                schedules: [
                    {
                        id: '123456',
                        name: 'Appollo Release Rotation',
                    },
                ],
            },
        },
        {
            id: 'crowdin:abcdefg',
            type: 'crowdin',
            name: 'Crowdin',
            appIds: ['appollo-ios', 'appollo-android', 'appollo-react-native-ota'],
            installedIntegrationTypesByAppId: {
                'appollo-ios': ['crowdin'],
                'appollo-android': ['crowdin'],
                'appollo-react-native-ota': ['crowdin'],
            },
            data: {
                onPremDomain: 'www.appollo-domain.com',
                projects: [
                    {
                        id: '123456',
                        name: 'appollo project',
                        key: 'appollo-key',
                        identifier: 'appollo-identifier',
                        url: 'https://crowdin.com/project/appollo',
                    },
                    {
                        id: '622958',
                        name: 'appollo project',
                        key: 'appollo-ios',
                        identifier: 'appollo-ios',
                        url: 'https://crowdin.com/project/appollo-ios',
                    },
                ],
            },
        },
        {
            id: 'expo-eas:12345',
            type: 'expo-eas',
            name: 'Expo EAS',
            appIds: ['voyager'],
            installedIntegrationTypesByAppId: {
                voyager: ['expo-eas'],
            },
            data: {
                accountId: 'runway-demo',
                projects: [
                    {
                        id: '4db9d6ca-2c5f-4f45-a955-78ac97c3fa31',
                        name: 'Voyager',
                        slug: 'voyager',
                        fullName: '@runway-demo/voyager',
                        owner: 'runway-demo',
                    },
                ],
                channels: {
                    '4db9d6ca-2c5f-4f45-a955-78ac97c3fa31': [
                        { id: 'production', name: 'production' },
                        { id: 'preview', name: 'preview' },
                    ],
                },
            },
        },
    ],
};
